// sso-warning: build-time config for the email/password sign-in deprecation
// notice. Per-environment values live in frontend/.env.{ENV} (12-factor);
// components never read import.meta.env directly.

/** sessionStorage key for the per-session banner dismissal (set by the banner, cleared on sign-out). */
export const SSO_WARNING_DISMISSED_KEY = 'banyan_sso_warning_dismissed';

/** BanyanSSO self-service URL, or '' when unset/blank. */
export function getSsoSelfServiceUrl() {
  const raw = import.meta.env.VITE_SSO_SELFSERVICE_URL;
  return typeof raw === 'string' ? raw.trim() : '';
}
